const share = {
    state: {
        shareOriginData: {
            title: "天安金交中心",
            desc: "您身边的财富管家",
            link: window.location.href,
            imgUrl:  "https://tianbaolian.oss-cn-shanghai-finance-1-pub.aliyuncs.com/baolian/2021120810/17b30c56-17d4-4f40-8d18-1343cf613dde.jpg" // 分享图标
        },
    },
    getters: {

    },
    mutations: {

    },
    actions: {

    }
}

export default share